import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { BaseSiteService, CmsService } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { DataLayerService } from 'src/app/shared/services/data-layer.service';
@Component({
    selector: 'app-account-confirmation-information',
    templateUrl: './account-confirmation-information.component.html',
    styleUrls: ['./account-confirmation-information.component.scss'],
    standalone: false
})
export class AccountConfirmationInformationComponent
  implements OnInit, OnDestroy
{
  accountData: any;
  compName = 'AccountRegistrationConfirmationBannerComponent';
  creditInvoice: string;
  cmsResponse: any;
  baseSiteId: any;
  header: any;
  finalNeedAss: any;
  baseSub: Subscription;
  cmsSub: Subscription;

  constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly cmsData: CmsService,
    private readonly baseSiteService: BaseSiteService,
    private readonly _dataLayerService: DataLayerService
  ) {}

  ngOnInit(): void {
    window.scroll(0, 0);
    this.creditInvoice = 'invoiceTable';
    this.header = 'confirmation';
    this.accountData = JSON.parse(
      localStorage.getItem('accountConfirmationData')
    );
    this.baseSub = this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));
    let baseSiteNeedAssistanceComp;
    if (this.baseSiteId === 'vsh') {
      baseSiteNeedAssistanceComp = 'NeedAssistanceComponent';
    } else {
      baseSiteNeedAssistanceComp = 'NeedAssistanceComponentCustomerRegister';
    }
    this.cmsSub = this.cmsData
      .getComponentData(baseSiteNeedAssistanceComp)
      .subscribe((res) => {
        this.cmsResponse = res;
        const arrContent = this.cmsResponse.content.split(
          '<span class=Need-assistance>'
        );
        if (this.baseSiteId === 'vsh') {
          this.finalNeedAss = '<span class=Need-assistance>' + arrContent[0];
        } else {
          this.finalNeedAss = '<span class=Need-assistance>' + arrContent[1];
        }

        this.cdr.detectChanges();

        this._dataLayerService.addtoDataLayer('accReg', 'sign_up');
      });
    this.cdr.detectChanges();

    this._dataLayerService.addtoDataLayer(
      'accReg_FormEvent',
      '',
      '',
      '',
      'form_step',
      'confirmation'
    );
  }
  ngOnDestroy(): void {
    this.baseSub?.unsubscribe();
    this.cmsSub?.unsubscribe();
  }
}
